export interface DrawingPageContent {
  event_name: string;
  headline: string;
  subheadline: string;
  intro: string;
  hero_image: string;
  prize_image: string;
  prizes: string[];
  fine_print: string;
  show_qr: boolean;
  phone: string;
  success_message: string;
}

export const DEFAULT_DRAWING_CONTENT: DrawingPageContent = {
  event_name: "",
  headline: "Door Prize Drawing",
  subheadline: "Enter for a chance to win!",
  intro:
    "Welcome to the Rex & Sons RVs booth! Fill out the quick form for your official entry into our prize drawing.",
  hero_image: "",
  prize_image: "",
  prizes: [],
  fine_print: "One entry per person. Winners drawn after the show closes.",
  show_qr: true,
  phone: "910-679-6522",
  success_message:
    "Your entry has been submitted. Winners will be announced after the drawing. Good luck!",
};

export function normalizeDrawingContent(value: unknown): DrawingPageContent {
  const v = (value ?? {}) as Partial<DrawingPageContent>;
  return {
    ...DEFAULT_DRAWING_CONTENT,
    ...v,
    prizes: Array.isArray(v.prizes) ? v.prizes.filter(Boolean) : [],
  };
}
